import React, { useEffect } from "react";
import FlipCardSlider from "../../components/Slider/FlipCardSlider";
import ArticleContainer from "../../components/Article/ArticleContainer";
import ArticleHero from "../../components/Hero/ArticleHero";


const relatedBlogs = [
  {
    contentType: "BLOG",
    title: "Complimenting Fleet Modernization with Road Safety",
    description: "Shoora is leading the charge in transforming fleet operations by enhancing safety and operational efficiency through the Voluntary Vehicle-Fleet Modernization Programme (VVMP).",
    link: "/insights/blog/complimenting-fleet-modernization-with-road-safety",
    linkText: "Read article",
    thumbnail:
      "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  readTime: 10,
    },
  {
    contentType: "BLOG",
    title: "Envisioning the Future of Mobility with Shoora",
    description:
      "Shoora offers comprehensive fleet management solutions that track vehicle locations, monitor driver performance, optimise routes, and reduce fuel consumption.",
    thumbnail:
      "/images/thumbnails/14.jpeg",
    link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
  readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Leverage AIS-140’s Mandate for Telematics Devices",
    description:
      "Shoora, a leader in advanced video telematics solutions , is committed to harnessing the potential of this mandate to create safer roads and smarter transportation systems.",
    thumbnail: "https://www.easyembedded.net/images/ais2.jpg",
    link: "/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles",
  readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Tackling Distracted Driving: Transforming Fleet Safety",
    description:
      "By adopting the Three Ts—Talk, Train, and Track, Shoora addresses distracted driving head-on, protecting lives and optimising operations.",
    thumbnail: "/images/thumbnails/3.jpeg",
    link: "/insights/blog/tackling-distracted-driving-transforming-fleet-safety",
  readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
    description:
      "Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives.",
    thumbnail:
      "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
    link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
  readTime: 10,
  },
  {
    contentType: "CUSTOMER STORY",
    title: "Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
    description:
      "Shoora is not just a service provider for BLR Logistics; they are a trusted safety partner.",
    thumbnail:
      "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
    link: "/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents",
  readTime: 10,
  },

  {
    contentType: "CUSTOMER STORY",
    title: "Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres",
    description:
      "The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings.",
    thumbnail: "/images/thumbnails/15.jpeg",
    link: "/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions",
  readTime: 10,
  },
];
const data = {
  contentType: "EDUCATION AND TRAINING",
  title: "Shoora’s Commitment to Driver Education and Training",
  description:
    "At Shoora, we partner with government bodies to advance policies, ensure compliance, and drive innovation in transportation safety, efficiency, and sustainability.",
  author: "Shoora",
  createdOn: "26th Oct, 2024",
  imgsrc:
    "https://www.slalom.com/adobe/dynamicmedia/deliver/dm-aid--9dd9c6b8-7911-47d7-9fcb-77b374db4eb2/customer-love-landing.png?preferwebp=true&quality=85&width=1600",
  readTime: 10,
  content: `  <p>
        At Shoora, we believe that safer roads start with informed and empowered
        drivers. As a leading Telematics Solutions Provider, we combine
        <strong>cutting-edge AI, machine learning (ML), and IoT</strong> with
        robust driver training programs to address one of the biggest causes of
        accidents—<strong>distracted driving</strong>. Our mission is to save
        lives, protect fleets, and create a culture of safety in India’s
        transportation ecosystem.
      </p>

      <h2>Empowering Drivers Through Education</h2>
      <p>
        We focus on equipping drivers with the knowledge and tools they need to
        adopt safer driving practices. Our
        <strong>highly customizable e-modules</strong> and
        <strong>in-person coaching programs</strong> address key areas such as:
      </p>
      <ul>
        <li>
          <strong>Road Safety:</strong> Workshops on defensive driving, hazard
          awareness, and speed management.
        </li>
        <li>
          <strong>Health and Wellness:</strong> Regular screenings for
          hypertension, diabetes, and fatigue, paired with resources on
          nutrition and fitness.
        </li>
        <li>
          <strong>Mental Health Support:</strong> Stress management and mental
          well-being workshops to counter the challenges of long hours on the
          road
        </li>
        <li>
          <strong>De-addiction Programs:</strong> Awareness campaigns and
          counselling to help drivers overcome alcohol and tobacco dependency.
        </li>
      </ul>

      <h2>Rewarding Safe Driving</h2>
      <p>
        Through our <strong>HDScore system</strong>, we track driver performance
        and reward safe behaviour. Drivers who respond to
        <strong>CabIn Alerts™</strong> in real-time and exhibit consistent
        improvement are recognized with performance-based rewards, encouraging
        long-term positive habits.
      </p>

      <h2>Advanced AI-Driven Safety Solutions</h2>
      <p>
        Shoora integrates state-of-the-art technology to enhance driver training
        on the go. Features like
        <strong>in-vehicle intelligence, real-time video analysis</strong>, and
        <strong>proactive alerts</strong> ensure drivers stay focused and make
        better decisions under pressure.
      </p>
      <ul>
        <li>
          <strong>CabIn Alerts™:</strong> AI-powered systems detect distractions
          like mobile phone usage, smoking, or fatigue and provide immediate
          feedback in vernacular languages.
        </li>
        <li>
          <strong>On-Demand Video Retrieval:</strong> Instant access to event
          footage helps identify risky behaviours and train drivers effectively.
        </li>
        <li>
          <strong>Predictive Decision-Making:</strong> AI and ML tools analyse
          driving patterns, enabling proactive interventions.
        </li>
      </ul>

      <h2>Creating a Culture of Safety</h2>
      <p>
        By combining education, advanced technology, and driver engagement,
        Shoora fosters a culture where safety is prioritised across the fleet.
        From empowering drivers with knowledge to ensuring fleet operators have
        complete visibility into operations, we’re redefining safety in the
        logistics and transportation industry.
        <br />
        <br />
        Join us in building a
        <strong>
          safer, smarter, and more efficient future for India’s roads
        </strong>
        . Together, we can save lives, protect businesses, and transform the
        driving experience for all.
      </p>`,
};
const EducationAndTraining = () => {
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <>
      <ArticleHero
        contentType={data?.contentType}
        title={data?.title}
        createdOn={data?.createdOn}
        imgsrc="/images/about/bg8.webp"
      />
      <div className="bg-dark">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Insights</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#" className="text-capitalize">
                  {data?.contentType}s
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {data?.title}
              </li>
            </ol>
          </nav>
        </div>
      </div>

      

      <ArticleContainer data={data} />
      <hr className="border-3" style={{ borderColor: "var(--accent-color)" }} />
      <div
                className="stories-section section my-5"
                style={{ maxWidth: "100%" }}
            >
                <div className="container">
                    
                <FlipCardSlider data={relatedBlogs} title={"You may also like"}/>
                </div>
            </div>
    </>
  );
};

export default EducationAndTraining;
